import { LOCATION_CHANGE } from 'react-router-redux';
import { handleActions } from 'redux-actions';
import { mapReducersFromConfigurations } from '../../helpers/reducer';
import { attemptConfigurations, questionAttemptConfigurations, questionConfigurations } from './configurations';

const resource = (resourceName, result) => ({
  [resourceName]: {
    result,
    relatedTasks: [],
    isFetching: false,
    error: null
  }
});

export const initialState = {
  ...resource('questions', []),
  ...resource('attempts', []),
  ...resource('submittedAnswer', null)
};

const reducer = handleActions({
  ...mapReducersFromConfigurations('questions')(questionConfigurations),
  ...mapReducersFromConfigurations('attempts')(attemptConfigurations),
  ...mapReducersFromConfigurations('questionAttempts')(questionAttemptConfigurations),
  [LOCATION_CHANGE]: (state, action) => initialState
}, {
    ...initialState
  });

export default reducer;



// WEBPACK FOOTER //
// ./src/state/modules/quiz/reducers.js